<template>
  <div
    v-if="isLoading"
    class="fixed inset-0 z-[99999] flex items-center justify-center bg-black-100 bg-opacity-40 p-4 text-white-100"
  >
    <LoaderCircle :size="50" :stroke-width="1" class="spin" />
  </div>
</template>

<script>
import { useLoaderStore } from "@S/loader";
import { LoaderCircle } from "lucide-vue-next";

export default {
  name: "Loader",
  components: {
    LoaderCircle,
  },
  setup() {
    const loaderStore = useLoaderStore();
    return { loaderStore };
  },
  computed: {
    isLoading() {
      return this.loaderStore.loading;
    },
  },
};
</script>
